<template>
  <div>
    <el-card class="box-card">
      <div class="title mt20">销售出库</div>
      <el-form :model="addForm" ref="addFormRef" label-width="100px">
        <el-form-item label="类别" class="addAdminForm">
          <el-input v-model="addForm.leibie" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" class="addAdminForm">
          <el-input v-model="addForm.name" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="规格/型号" class="addAdminForm">
          <el-input v-model="addForm.guige" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="代理商单价" class="addAdminForm">
          <el-input v-model="addForm.dlsdanjia" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="建议零售单价" class="addAdminForm">
          <el-input v-model="addForm.jianyisaledanjia" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="销售日期" class="addAdminForm">
          <el-date-picker v-model="addForm.saleriqi" type="date" placeholder="销售日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="销售员" class="addAdminForm">
          <el-input v-model="addForm.saleren" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="零售单价" class="addAdminForm">
          <el-input v-model="addForm.saledanjia" placeholder="" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item label="零售数量" class="addAdminForm">
          <el-input v-model="addForm.num" placeholder="" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item label="零售金额" class="addAdminForm">
          <el-input v-model="addForm.saleamount" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户名称" class="addAdminForm">
          <el-input v-model="addForm.kehuname" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户信息来源" class="addAdminForm">
          <el-select v-model="addForm.kehulaiyuan" placeholder="请选择" style="width: 100%">
            <el-option label="自行到店" value="自行到店"></el-option>
            <el-option label="销售员拓展" value="销售员拓展"></el-option>
            <el-option label="转介绍" value="转介绍"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" class="addAdminForm">
          <el-input v-model="addForm.kehudianhua" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="附件" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.beizhu" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">销售出库记录</div>
      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
        <el-table-column prop="Saleriqi" label="销售日期" min-width="10%"></el-table-column>
        <el-table-column prop="Saleren" label="销售员" min-width="10%"></el-table-column>
        <el-table-column prop="Leibie" label="类别" min-width="10%"></el-table-column>
        <el-table-column prop="Name" label="名称" min-width="10%"></el-table-column>
        <el-table-column prop="Guige" label="规格/型号" min-width="10%"></el-table-column>
        <el-table-column prop="Saledanjia" label="零售单价" min-width="10%"></el-table-column>
        <el-table-column prop="Num" label="零售数量" min-width="10%"></el-table-column>
        <el-table-column prop="Saleamount" label="零售金额" min-width="10%"></el-table-column>
        <el-table-column prop="Kehuname" label="客户名称" min-width="10%"></el-table-column>
        <el-table-column prop="Kehulaiyuan" label="客户信息来源" min-width="10%"></el-table-column>
        <el-table-column prop="Kehudianhua" label="联系电话" min-width="10%"></el-table-column>
        <el-table-column label="附件" min-width="7%">
          <template v-slot="scope">
            <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
        <el-table-column prop="Createusername" label="操作人" min-width="10%"></el-table-column>
        <el-table-column prop="CreateTime" label="操作时间" min-width="15%"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCunOutSale_Delete">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
  },
  data () {
    return {
      addForm: {
        jigouid: '-1',
        saleriqi: '',
        saleren: '',
        leibie: '',
        name: '',
        guige: '',
        dlsdanjia: '',
        jianyisaledanjia: '',
        saledanjia: '',
        num: '',
        saleamount: '',
        kehuname: '',
        kehulaiyuan: '',
        kehudianhua: '',
        attachment: '',
        beizhu: ''
      },
      dataList: [],
      SubRule_MenDianPurchaseSalesKuCunOutSale_Delete: false
    }
  },
  methods: {
    LoadData (row) {
      this.addForm.jigouid = row.Jigouid
      this.addForm.leibie = row.Leibie
      this.addForm.name = row.Name
      this.addForm.guige = row.Guige
      this.addForm.dlsdanjia = row.Dlsdanjia
      this.addForm.jianyisaledanjia = row.Saledanjia
      this.apiGetMenDianPurchaseSalesKuCunOutSaleList()

      var that = this
      Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesKuCunOutSale_Delete', function (response) {
        if (response.data.Code === 200) {
          that.SubRule_MenDianPurchaseSalesKuCunOutSale_Delete = true
        }
      })
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.attachment = url
    },
    processAmount (){
      var buf = Number(this.addForm.saledanjia) * Number(this.addForm.num)
      this.addForm.saleamount = this.pnum(buf)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddMenDianPurchaseSalesKuCunOutSale()
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickDelete (row) {
      this.$confirm('是否删除此领用出库记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteMenDianPurchaseSalesKuCunOutSale(row.Id)
      })
    },
    apiAddMenDianPurchaseSalesKuCunOutSale: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.addForm.jigouid,
        saleriqi: this.addForm.saleriqi,
        saleren: this.addForm.saleren,
        leibie: this.addForm.leibie,
        name: this.addForm.name,
        guige: this.addForm.guige,
        saledanjia: this.addForm.saledanjia,
        num: this.addForm.num,
        saleamount: this.addForm.saleamount,
        kehuname: this.addForm.kehuname,
        kehulaiyuan: this.addForm.kehulaiyuan,
        kehudianhua: this.addForm.kehudianhua,
        attachment: this.addForm.attachment,
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMenDianPurchaseSalesKuCunOutSale, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetMenDianPurchaseSalesKuCunOutSaleList()
            that.addForm.saleriqi = ''
            that.addForm.saleren = ''
            that.addForm.saledanjia = ''
            that.addForm.num = ''
            that.addForm.saleamount = ''
            that.addForm.kehuname = ''
            that.addForm.kehulaiyuan = ''
            that.addForm.kehudianhua = ''
            that.addForm.attachment = ''
            that.addForm.beizhu = ''
            that.$refs.MultiImgOrPdf.cleardata()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMenDianPurchaseSalesKuCunOutSaleList: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.addForm.jigouid,
        name: this.addForm.name,
        guige: this.addForm.guige
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesKuCunOutSaleList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DeleteMenDianPurchaseSalesKuCunOutSale: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteMenDianPurchaseSalesKuCunOutSale, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetMenDianPurchaseSalesKuCunOutSaleList()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}
</style>
